import React from 'react';
import { useNavigate } from 'react-router';
import {Modal, ModalHeader, ModalBody, ModalFooter} from "../../../../components/Modal";
import CustomButton from "../../../../components/CustomButton";

import { useTranslation } from 'react-i18next';

import checkmarkIcon from 'url:shared-assets/icons/green/badge-check-filled.svg';
import calendarIcon from 'url:shared-assets/icons/calendar.svg';
import clockIcon from 'url:shared-assets/icons/gray/clock.svg';
import {dateFormatHourMinute} from "../../../../helpers/dateFunctions";
import {getLanguage} from "../../../../lang/helpers";


interface BookingSuccessModalProps {
    onClose: () => void;
    fromMeeting?: boolean
    isOpen: boolean;
    coachName: string;
    selectedDate: Date|null;
    meetingId: string|null;
}

const BookingSuccessModal: React.FC<BookingSuccessModalProps> = ({ onClose, isOpen,
                                                                     fromMeeting, coachName, selectedDate, meetingId }) => {
    const { t, i18n } = useTranslation();
    const lang = getLanguage(i18n.language)
    const navigate = useNavigate();

    if (!selectedDate) {
        return null;
    }

    // convert date to format dd monthname for example 18 nov
    const date = selectedDate.toLocaleDateString(lang, {
        day: 'numeric',
        month: 'long',
    })

    return ( 
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalHeader onClose={onClose}>
                <div className="z-title1">
                    {meetingId ? t('meeting-changed') : t('meeting-booked')}
                </div>
            </ModalHeader>
            <ModalBody>
                <div className="flex flex-col justify-between gap-3 ">
                    <div className="flex flex-row justify-center">
                        <img src={checkmarkIcon} alt="Cancel meeting" className="w-12 h-12 my-3" />
                    </div>
                    <div className="flex flex-row align-middle items-center gap-1">
                        <p className="z-body1">
                            {t('video-coaching-with', { coach: coachName })}
                        </p>
                    </div>

                    <div className="flex flex-row align-middle items-center gap-1">
                        <img src={calendarIcon} alt="Cancel meeting" className="w-6 h-6" />
                        <p className="z-body1">
                            {date}
                        </p>
                    </div>

                    <div className="flex flex-row align-middle items-center gap-1">
                        <img src={clockIcon} alt="Cancel meeting" className="w-6 h-6" />
                        <p className="z-body1">
                            {dateFormatHourMinute(selectedDate)}
                        </p>
                    </div>
                </div>
            </ModalBody>
            <ModalFooter>
                {
                    fromMeeting ? (
                      <CustomButton onClick={onClose} buttonType="outlineWhiteBase">
                          {lang === 'sv' ? 'Stäng' : 'close'}
                      </CustomButton>
                    ) : (
                      <>
                          <CustomButton onClick={onClose}>
                              {lang === 'sv' ? 'Boka fler möten' : 'Book more meetings'}
                          </CustomButton>
                          <CustomButton onClick={() => navigate('/videocoach')} buttonType="outlineWhiteBase">
                              {lang === 'sv' ? 'Tillbaka till videocoach-sidan' : 'Back to video coach page'}
                          </CustomButton>
                      </>
                    )
                }
            </ModalFooter>
        </Modal>
    );
};

export default BookingSuccessModal;